

export default class Truncate {
/**
* Truncate constructor, receives props from `initModules`
* @param {HTMLElement} $el
* @param {Object} opts
*/
  constructor($el, opts) {
    this.$el = $el;
    this.options = opts;
  }

  init() {
    const count = this.getWordCount(this.options);
    this.addTruncatedText(count);
  }

/* truncateString()
 * @params string string;
 * @params int count;
 * @return string
 * Split string into an array, if array.length > count slice first count amount then convert back
 * to string and add elipsis else return the original string */
  
  truncateString(string, count) {
    const stringArray = string.split(' ');
    return stringArray.length > count ? stringArray.slice(0, count).join(' ') + '...' : string;
  }

  /* getWordCount()
   * @params {} options;
   * @return int word count limit before truncate
   * Return int count from converting the data-truncate-words to int */

  getWordCount(options) {
    return parseInt(options.words);
  }

  /* truncateString()
  * @params int count;
  * @return void
  * Injecting the truncated text back into the element */

  addTruncatedText(count) {
    this.$el.innerText = this.truncateString(this.$el.innerText, count);
  }
}



// WEBPACK FOOTER //
// ./js/modules/Truncate.js